import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import  breadcrumb  from './components/breadcrumb'
//引入公共的样式文件
import './static/css/reset.less'
import './static/css/common.less'

// 引入axios 文件
import axios from './utils/axios'
import utils from './utils/utils'

// 引入API 文件
import api from "@/request/api";

// 挂载在axios上
Vue.prototype.$axios = axios
Vue.prototype.$utils = utils
Vue.prototype.$api = api
Vue.config.productionTip = false
Vue.config.silent = false

Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.component("Bread", breadcrumb);
//初始化语言包
const i18n = new VueI18n({
  locale: utils.getNowLang() || 'chs',
  messages: {
    'chs': require('./assets/languages/chs.js'),
    'en': require('./assets/languages/en.js')
  }
});
//路由跳转之前进行判断
router.beforeEach((to, from, next) =>{
	if(to.meta.title){
		document.title = to.meta.title
	}
	next()
})
new Vue({
  render: h => h(App),
  i18n,
  router,
  store
}).$mount('#app')